<template>
  <div
    v-if="isHolding"
    class="escape-hold-indicator"
    :style="{ '--escape-hold-duration': `${holdDuration}ms` }"
    role="status"
    aria-label="Håll Escape för att byta användare"
  >
    <div class="escape-hold-indicator__track">
      <div class="escape-hold-indicator__progress"></div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.escape-hold-indicator {
  position: fixed;
  z-index: 1000;
  bottom: 16px;
  left: 50%;
  width: min(160px, calc(100vw - 32px));
  padding: 4px;
  background: rgba(33, 33, 33, 0.92);
  border-radius: 6px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  opacity: 0;
  pointer-events: none;
  transform: translateX(-50%);
  animation: reveal-escape-hold 0s linear 200ms forwards;
}

.escape-hold-indicator__track {
  height: 3px;
  overflow: hidden;
  background: rgba(255, 255, 255, 0.24);
  border-radius: 2px;
}

.escape-hold-indicator__progress {
  width: 100%;
  height: 100%;
  background: var(--v-secondary-base);
  border-radius: inherit;
  transform: scaleX(0);
  transform-origin: left;
  animation: fill-escape-hold var(--escape-hold-duration) linear forwards;
}

@keyframes reveal-escape-hold {
  to {
    opacity: 1;
  }
}

@keyframes fill-escape-hold {
  to {
    transform: scaleX(1);
  }
}
</style>

<script>
const HOLD_DURATION = 1000

export default {
  data: () => ({
    holdDuration: HOLD_DURATION,
    isHolding: false,
    holdTimer: null
  }),
  methods: {
    handleKeyDown (event) {
      if (event.key !== 'Escape' || event.repeat || this.holdTimer !== null) {
        return
      }

      this.isHolding = true
      this.holdTimer = window.setTimeout(() => {
        this.holdTimer = null
        this.isHolding = false
        this.$store.dispatch('user/deactivateAuthSession')
      }, this.holdDuration)
    },
    handleKeyUp (event) {
      if (event.key === 'Escape') {
        this.cancelHold()
      }
    },
    cancelHold () {
      if (this.holdTimer !== null) {
        window.clearTimeout(this.holdTimer)
        this.holdTimer = null
      }

      this.isHolding = false
    }
  },
  mounted () {
    document.addEventListener('keydown', this.handleKeyDown)
    document.addEventListener('keyup', this.handleKeyUp)
    window.addEventListener('blur', this.cancelHold)
  },
  beforeDestroy () {
    document.removeEventListener('keydown', this.handleKeyDown)
    document.removeEventListener('keyup', this.handleKeyUp)
    window.removeEventListener('blur', this.cancelHold)
    this.cancelHold()
  }
}
</script>
